module.exports = __webpack_public_path__ + "static/TreeSwing-a44d6cb32bb85435a0ea1fa09305453d.webm";